import { render, staticRenderFns } from "./rewardMiningRankEdit.vue?vue&type=template&id=2455890e&scoped=true&"
import script from "./rewardMiningRankEdit.vue?vue&type=script&lang=js&"
export * from "./rewardMiningRankEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2455890e",
  null
  
)

export default component.exports